<template>
  <div id="wrapper">
    <Sidebar :menu="menu" :user="user" />

    <div id="page-wrapper" class="gray-bg">
      <Topbar />

      <b-overlay :show="isShow" z-index="1000">
        <router-view></router-view>

        <template #overlay>
          <div class="text-center">
            <b-spinner></b-spinner>
            <h4 class="mt-2">{{ loadingMessage }}</h4>
          </div>
        </template>
      </b-overlay>

      <Footer />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenus } from "@/config/menu";
import { removeCls } from "@/lib/ui/domClass";
import Topbar from "@/components/layout/Topbar";
import Sidebar from "@/components/layout/sidebar/Sidebar";
import Footer from "@/components/layout/Footer";

export default {
  name: "Main",
  data() {
    return {
      menu: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.session.user,
      isShow: (state) => state.overlay.show,
      loadingMessage: (state) => state.overlay.message,
    }),
  },
  components: {
    Topbar,
    Sidebar,
    Footer,
  },
  methods: {
    loadMenus() {
      let menuItems = getMenus();

      if (!this.user.admin) {
        menuItems = menuItems.filter((item) => {
          if (!item.tag) {
            return true
          }

          const tags = this.user.tags

          if (!tags.includes(item.tag)) {
            return false
          }

          if (item.children) {
            item.children = item.children.filter(itemChildren => tags.includes(itemChildren.tag))
          }

          return true
        });
      }

      this.menu = menuItems;
    },
  },
  created() {
    removeCls("body", "gray-bg");

    this.loadMenus();
  },
};
</script>

<style scoped>
#page-wrapper {
  padding-bottom: 60px !important;
}
</style>
